import { useCallback } from "react";
import { useToast } from "@vendor-app/app/_sharedComponents/Toast/ToastProvider";
import { GettingStartedStoreAccess } from "../../store";
import { setProductsInGroup } from "@vendor-app/app/AdminRoute/AdminSetupRoute/Tabs/SubscriptionSetup/libs/components/Cards/SubscriptionProductsCard";

export function useEditSellingPlanProducts(selectedSellingPlanId: string) {
  const { addToast } = useToast();
  const { fetchSellingPlanProductsAndVariants, setIsLoading, update } = GettingStartedStoreAccess.useActions();

  const updateProducts = useCallback(
    async (selectedIds: string[]) => {
      if (!selectedSellingPlanId) {
        addToast("No subscription program selected");
        return false;
      }

      const productIds = selectedIds.filter(id => id.includes("Product/"));
      const variantIds = selectedIds.filter(id => id.includes("ProductVariant/"));

      setIsLoading(true, "subscriptionProgram");

      try {
        await setProductsInGroup(selectedSellingPlanId, {
          productIds,
          productVariantIds: variantIds,
        });

        update(
          [
            {
              path: "subscriptionSetup.product",
              val: {
                completed: true,
                date: new Date().toISOString(),
                demo: false,
              },
            },
          ],
          "subscriptionProgram"
        );

        fetchSellingPlanProductsAndVariants(selectedSellingPlanId);

        addToast("Products updated");

        return true;
      } catch {
        addToast("Something went wrong updating products", true);
        return false;
      } finally {
        setIsLoading(false, "subscriptionProgram");
      }
    },
    [selectedSellingPlanId]
  );

  return updateProducts;
}
